module.exports = __webpack_public_path__ + "img/c03_unitfishingboat_Normal_ua.71ada1f5.webp";